import { render, staticRenderFns } from "./RGReportDetailsModal.vue?vue&type=template&id=56749c1a&scoped=true&"
import script from "./RGReportDetailsModal.vue?vue&type=script&lang=js&"
export * from "./RGReportDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./RGReportDetailsModal.vue?vue&type=style&index=0&id=56749c1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56749c1a",
  null
  
)

export default component.exports